<template>
    <section>
        <div v-if="isAuthorized('PerformanceDeclarePerformance') && performanceInfo.is_active_phase_to_declare && performanceInfo.is_emit != true"
            class="columns">
            <div class="column has-text-right">
                <b-button v-if="performanceInfo.id" :label="`Editar compromisos ${performanceInfo.phase.year}`"
                    icon-left="edit" type="is-warning" tag="a" href="/performances/declare" target="_blank" />
                <b-button v-else
                    :label="performanceInfo.phase.phase_d_type_id === 1 ? 'Declarar Compromisos ' + performanceInfo.phase.year : 'Declarar Horas Realizadas ' + performanceInfo.phase.year"
                    icon-left="plus" type="is-primary" tag="a" href="/performances/declare" target="_blank" />
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <div class="title is-5 has-text-centered">
                    Tabla de Procesos de Convenio de Desempeño
                    <hr class="dropdown-divider" aria-role="menuitem">
                </div>
            </div>
        </div>

        <ValidationObserver class="columns" ref="observer">
            <ValidationProvider class="column" :rules="{ start_date_before_end_date: maxYear, required: true }"
                v-slot="{ errors, failedRules }">
                <b-field label="Año Desde *" :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                    :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                    <multiselect v-model="minYear" :options="years" :searchable="true" :close-on-select="true"
                        :allow-empty="true" selectLabel="Presione para seleccionar" selectedLabel="Seleccionado"
                        deselectLabel="Presione para deseleccionar" placeholder="Elija un Año" />
                </b-field>
            </ValidationProvider>

            <ValidationProvider class="column" :rules="{ end_date_not_before_start_date: minYear, required: true }"
                v-slot="{ errors, failedRules }">
                <b-field label="Año Hasta *" :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                    :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                    <multiselect v-model="maxYear" :options="years" :searchable="true" :close-on-select="true"
                        :allow-empty="true" selectLabel="Presione para seleccionar" selectedLabel="Seleccionado"
                        deselectLabel="Presione para deseleccionar" placeholder="Elija un Año" />
                </b-field>
            </ValidationProvider>

            <div class="column is-narrow">
                <br>
                <b-field label=" ">
                    <b-button icon-left="search" type="is-info" label="Aplicar Filtro" @click="check()" />
                </b-field>
            </div>
        </ValidationObserver>

        <b-table :data="performances" striped hoverable>
            <b-table-column label="Año" field="year" v-slot="props">
                {{ props.row.last_phase.year }}
            </b-table-column>

            <b-table-column label="Última Fase" field="last_phase" v-slot="props">
                {{ props.row.phase_alt_name }}
            </b-table-column>

            <b-table-column label="Acciones" width="100" v-slot="props">
                <b-button icon-left="eye" type="is-primary" tag="a"
                    :href="`/performances/process/${props.row.last_phase.year}/person/${person.id}`" target="_blank" />
            </b-table-column>

            <template slot="empty" slot-scope="props">
                <div class="columns is-centered">
                    <div class="column is-6 is-centered has-text-centered">
                        <b-message type="is-warning">
                            No existen Registros de Desempeños.
                        </b-message>
                    </div>
                </div>
            </template>
        </b-table>

        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
export default {
    name: 'MyPerformances',

    props: [
        'objectId', 'componentType', 'cargoPrincipal', 'currentYear', 'hideUpdate', 'person', 'unit', 'canCreateDocument', 'permissions',
    ],

    data() {
        return {
            //Auxiliares
            isLoading: false,
            years: Array.from({ length: (new Date().getFullYear() - 2000 + 1) }, (v, k) => k + 2000).reverse(),
            semester: null,
            minYear: new Date().getFullYear() - 5,
            maxYear: new Date().getFullYear(),

            //Data a traer
            performances: [],
            performanceInfo: {
                is_active_phase_to_declare: false,
                phase: {
                    alt_name: '',
                    year: '',
                    start_date: '',
                    end_date: '',
                }
            }
        }
    },

    async created() {
        await this.getMyPerformances()
        await this.getPerformanceInfoForAcademic()
    },

    methods: {
        isAuthorized(name) {
            let permission = this.permissions.find(obj => obj.name === name)
            if (permission !== undefined) {
                return permission.value;
            }
            else {
                return false
            }
        },
        async getMyPerformances() {
            this.isLoading = true
            await axios
                .get('/performances/get-academic-performances.json', {
                    params: {
                        person_id: this.person.id,
                        minYear: this.minYear,
                        maxYear: this.maxYear,
                    }
                })
                .then(response => {
                    this.performances = response.data
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        iconPack: 'fa',
                        icon: 'times-circle',
                        confirmText: 'Ok',
                    })
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        async getPerformanceInfoForAcademic() {
            this.isLoading = true
            await axios
                .get('/performances/get-performance-info-for-academic.json', {
                    params: {
                        person_id: this.person.id
                    }
                })
                .then(response => {
                    this.performanceInfo = response.data
                    this.performanceInfo.phase.start_date = moment(this.performanceInfo.phase.start_date, ["YYYY-MM-DD", "DD-MM-YYYY"])
                    this.performanceInfo.phase.end_date = moment(this.performanceInfo.phase.end_date, ["YYYY-MM-DD", "DD-MM-YYYY"])
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        iconPack: 'fa',
                        icon: 'times-circle',
                        confirmText: 'Ok',
                    })
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        async check() {
            let valid = await this.$refs.observer.validate()
            if (!valid) {
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Los campos del Filtro de Años tienen errores.',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return
            }

            await this.getMyPerformances()
        }
    }
}
</script>